import React from "react";
import { FaFilter, FaRedo, FaSearch, FaTimes } from "react-icons/fa";

import { MEMBERS_OPTIONS, STATUS_OPTIONS } from "../utils/adminGroupsUtils";

function GroupFilters({
  filters,
  coachOptions,
  refreshing,
  onChange,
  onReset,
  onRefresh,
}) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-sky-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
            <FaFilter />
            Filtres groupes
          </div>

          <h2 className="mt-3 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Rechercher un groupe
          </h2>

          <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
            Recherche par nom de groupe, coach ou adhérent rattaché.
          </p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onReset}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-bold text-slate-600 transition hover:border-red-200 hover:text-red-600 dark:border-white/10 dark:bg-white/[0.05] dark:text-white/70"
          >
            <FaTimes />
            Réinitialiser
          </button>

          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
          >
            <FaRedo className={refreshing ? "animate-spin" : ""} />
            {refreshing ? "Actualisation..." : "Actualiser"}
          </button>
        </div>
      </div>

      <div className="mt-5 grid gap-3 xl:grid-cols-[1.3fr_0.7fr_0.7fr_0.7fr]">
        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Recherche
          </span>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="search"
              value={filters.search}
              onChange={(event) => onChange("search", event.target.value)}
              placeholder="Nom, coach, adhérent..."
              className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 pl-11 pr-4 text-sm font-bold text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
            />
          </div>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Statut
          </span>

          <select
            value={filters.status}
            onChange={(event) => onChange("status", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value || "all"} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Adhérents
          </span>

          <select
            value={filters.members}
            onChange={(event) => onChange("members", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            {MEMBERS_OPTIONS.map((option) => (
              <option key={option.value || "all"} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Tri
          </span>

          <select
            value={filters.sort}
            onChange={(event) => onChange("sort", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            <option value="nameAsc">Nom A → Z</option>
            <option value="nameDesc">Nom Z → A</option>
            <option value="membersDesc">Plus d’adhérents</option>
            <option value="membersAsc">Moins d’adhérents</option>
            <option value="orderAsc">Ordre groupe</option>
            <option value="recent">Plus récents</option>
            <option value="oldest">Plus anciens</option>
          </select>
        </label>
      </div>

      <div className="mt-3">
        <label className="block">
          <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            Coach / utilisateur
          </span>

          <select
            value={filters.coach}
            onChange={(event) => onChange("coach", event.target.value)}
            className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
          >
            <option value="">Tous les coachs</option>

            {coachOptions.map((coachName) => (
              <option key={coachName} value={coachName}>
                {coachName}
              </option>
            ))}
          </select>
        </label>
      </div>
    </section>
  );
}

export default GroupFilters;